// extracted by mini-css-extract-plugin
export default {"container":"styles_container__VYMl8","green_btn":"styles_green_btn__S2k35","success_img":"styles_success_img__lJ0-9"};